import { Link } from "@tanstack/react-router";
import { btn } from "@/components/ds/styles";
import { Drawer as DrawerPrimitive } from "vaul";
import { X } from "lucide-react";
import { Drawer, DrawerPortal, DrawerTitle, DrawerDescription } from "@/components/ui/drawer";
import { SITE_NAV, isNavActive } from "@/components/public/site-nav";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pathname: string;
  signedIn: boolean;
  onSignOut: () => void;
  showResume: boolean;
  langSearch: { lang?: "ar" | "en" };
};

const rowLink =
  "flex min-h-[52px] items-center justify-between rounded-ds-md px-4 font-display text-[17px] font-bold text-brown-700 transition-colors duration-ds-fast ease-ds hover:bg-cream-100";

export function MobileMenuSheet({ open, onOpenChange, pathname, signedIn, onSignOut, showResume, langSearch }: Props) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} shouldScaleBackground={false}>
      <DrawerPortal>
        <DrawerPrimitive.Overlay className="fixed inset-0 z-50 bg-ink/35" />
        <DrawerPrimitive.Content
          id="site-header-mobile-nav"
          className="fixed inset-x-0 bottom-0 z-50 flex max-h-[92dvh] flex-col overflow-y-auto rounded-t-ds-xl bg-surface px-5 pb-7 pt-3 shadow-lg outline-none"
        >
          <div aria-hidden className="mx-auto h-[5px] w-11 rounded-ds-pill bg-ink/20" />
          <div className="mt-3 flex items-center justify-between">
            <DrawerTitle className="font-display text-[19px] font-extrabold text-brown-700">القائمة</DrawerTitle>
            <DrawerDescription className="sr-only">روابط الموقع والحساب</DrawerDescription>
            <DrawerPrimitive.Close
              aria-label="إغلاق القائمة"
              className="grid h-12 w-12 place-items-center rounded-full bg-cream-100 text-brown-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              <X className="h-5 w-5" strokeWidth={1.75} />
            </DrawerPrimitive.Close>
          </div>

          <nav aria-label="القائمة الرئيسية" className="mt-3 flex flex-col gap-1">
            {SITE_NAV.map((n) => {
              const active = isNavActive(n.to, pathname);
              return (
                <Link
                  key={n.to}
                  to={n.to as any}
                  aria-current={active ? "page" : undefined}
                  className={`${rowLink} ${active ? "bg-amber-100" : ""}`}
                >
                  <span>{n.label}</span>
                  {"free" in n && n.free && (
                    <span className="rounded-ds-pill bg-green-100 px-3 py-1 font-display text-[13px] font-bold text-green-800">
                      مجاناً
                    </span>
                  )}
                </Link>
              );
            })}
          </nav>

          <hr className="my-3 border-0 border-t border-hairline-subtle" />

          <div className="flex flex-col gap-1">
            {signedIn ? (
              <>
                <Link to="/portal" className={rowLink}>لوحتي</Link>
                <button type="button" onClick={onSignOut} className={`${rowLink} text-start`}>
                  تسجيل الخروج
                </button>
              </>
            ) : (
              <Link to="/auth" search={{ mode: "sign_in" } as any} className={rowLink}>
                لوحتي · تسجيل الدخول
              </Link>
            )}
            {showResume && (
              <Link to="/bousala/play" search={langSearch as any} className={rowLink}>
                إكمال البوصلة
              </Link>
            )}
          </div>

          <Link
            to="/book"
            className={`${btn.primary} mt-4 min-h-[56px] shadow-accent`}
          >
            حجز استشارة
          </Link>
        </DrawerPrimitive.Content>
      </DrawerPortal>
    </Drawer>
  );
}
